var exports = {
  "q": "x4ddf2309--c6538a--badge",
};

module.exports = exports;
